/**
 * 域名相关配置，提供简单判断变量
 */
const debugLog = (...args: unknown[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

const getCurrentHostname = () => {
  if (process.env.NODE_ENV === 'development') {
    const domainParam = new URLSearchParams(window.location.search).get('domain');
    if (domainParam === 'huiya') return 'huiyabook.cn';
    if (domainParam === 'deerbook') return 'deerbook.cn';

    const mockHostname = (window as typeof window & { MOCK_HOSTNAME?: string | null }).MOCK_HOSTNAME;
    if (mockHostname) return mockHostname;
  }

  return window.location.hostname;
};

// 当前访问的主机名
const hostname = getCurrentHostname().toLowerCase();
debugLog('domain.ts - 使用的主机名:', hostname);

// 是否包含huiyabook.cn
const includesHuiyabook = hostname.includes('huiyabook.cn');
debugLog('domain.ts - hostname.includes("huiyabook.cn"):', includesHuiyabook);

// 是否包含huiya品牌域名
const includesHuiya = hostname.includes('huiya');
debugLog('domain.ts - hostname.includes("huiya"):', includesHuiya);

// 是否是绘芽域名
export const IS_HUIYA = includesHuiyabook || includesHuiya;
debugLog('domain.ts - IS_HUIYA计算结果:', IS_HUIYA);

// 是否是奇鹿域名（默认域名）
export const IS_DEERBOOK = !IS_HUIYA;
debugLog('domain.ts - IS_DEERBOOK:', IS_DEERBOOK);

// 获取当前使用的API域名
export const getApiDomain = () => {
  if (IS_HUIYA) {
    return 'https://api.huiyabook.cn';
  }
  return 'https://api.deerbook.cn';
};

// 根据当前域名获取网站名称
export const getSiteName = () => {
  debugLog('getSiteName()调用时的IS_HUIYA值:', IS_HUIYA);
  const name = IS_HUIYA ? '绘芽' : '奇鹿';
  debugLog('domain.ts - getSiteName() 返回:', name);
  return name;
};

// 根据当前域名获取网站Logo
export const getSiteLogo = () => {
  return IS_HUIYA ? '/logo-huiya.png' : '/logo-deerbook.png';
};

// 根据当前域名获取主题色
export const getPrimaryColor = () => {
  return IS_HUIYA ? '#1890ff' : '#1890ff';
};
